import { Container } from '@mui/material';
import React from 'react';
import {
    IFeedSuggestion,
    IFeedSuggestionContest,
    IFeedSuggestionEvents,
    IFeedSuggestionGigs,
    IFeedSuggestionUsers,
} from '../../redux/activity/types';
import { AdvertBanner } from '../VideoPlayer/AdvertBanner';
import { useThemeContext } from '../../hook/useThemeManager';
import { EventSuggestionCard } from '../Cards/EventSuggestionCard';
import { isEmpty } from '../../utils/lodash';
import { ContestSuggestionGroup } from '../Cards/ContestSuggestionGroup';
import { PersonSuggestionGroup } from '../Cards/PersonSuggestionGroup';
import { JobSuggestionCard } from '../Cards/JobSuggestionCard';

export interface ISuggestionContainer {
    suggestion?: IFeedSuggestion;
}

export const SuggestionContainer: React.FC<ISuggestionContainer> = ({ suggestion }) => {
    const { themeStyle } = useThemeContext();
    const { ads, contests, events, gigs, users } = suggestion || {};
    const { hotEvents } = (events as IFeedSuggestionEvents) || {};
    const { liveCampaigns } = (contests as IFeedSuggestionContest) || {};
    const { awardWinnersUsers } = (users as IFeedSuggestionUsers) || {};
    const { activeGigs } = (gigs as IFeedSuggestionGigs) || {};
    return (
        <Container disableGutters>
            {ads && !isEmpty(ads) && <AdvertBanner ad={ads[0]} themeStyle={themeStyle} />}
            {activeGigs && !isEmpty(activeGigs) && <JobSuggestionCard job={activeGigs[0]} />}
            {/** Suggested events */}
            {hotEvents && !isEmpty(hotEvents) && <EventSuggestionCard event={hotEvents[0]} />}
            {liveCampaigns && !isEmpty(liveCampaigns) && (
                <ContestSuggestionGroup contestsgroup={liveCampaigns} header="Live Campaigns" />
            )}
            {awardWinnersUsers && !isEmpty(awardWinnersUsers) && (
                <PersonSuggestionGroup awardList={awardWinnersUsers} />
            )}
        </Container>
    );
};
